import type { LandingVariant } from "./abVariant.js";

/**
 * Hero copy for the landing page.
 *
 * The three-way A/B/C test concluded on 2026-05-05 — channel-first (the
 * original B variant) was promoted to the site copy. The variant
 * infrastructure (`abVariant.ts`, GA4 variant tracking, `variant-report` CLI)
 * is intentionally left intact: the next test just swaps one or more of
 * `A` / `B` / `C` below to a fresh angle and the assignment, tracking, and
 * reporting machinery picks it up automatically.
 *
 * For the moment all three keys point at the same `PROMOTED` block, so every
 * visitor sees the same hero regardless of which arm they were assigned.
 */

export type HeroCopy = {
  eyebrow: string;
  headline: string;
  subhead: string;
  inclusion: string;
  cta: string;
};

const PROMOTED: HeroCopy = {
  eyebrow: "Inkling",
  headline: "The shared family calendar that lives in your text messages.",
  subhead:
    "Text, photo, or voice-note the family number with anything you want everyone to see — soccer practice, a school flyer, a dentist appointment. Inkling reads it, confirms when it's sure, asks when it isn't, and puts it on a calendar your whole family already has open.",
  inclusion:
    "Built for the way real households actually communicate — co-parents in two homes, blended families, multi-generational households, chosen family, roommates with shared kid pickups. If you coordinate plans together, Inkling works for you.",
  cta: "Get the family number",
};

export const LANDING_COPY: Record<LandingVariant, HeroCopy> = {
  A: PROMOTED,
  B: PROMOTED,
  C: PROMOTED,
};
